import { useTranslation } from "react-i18next";

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="w-full lg:w-2/5">
            <div className="relative">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Fashion%20lifestyle%20photography%20of%20a%20person%20holding%20a%20tablet%20displaying%20spreadsheet%20data%20surrounded%20by%20shopping%20bags%20and%20sneaker%20boxes%20in%20a%20bright%20modern%20loft%20apartment%2C%20natural%20window%20light%2C%20editorial%20quality%2C%20warm%20earthy%20color%20tones%2C%20casual%20authentic%20moment%2C%20modern%20retail%20lifestyle%2C%20aspirational%20aesthetic&width=700&height=875&seq=about-cssbuy-v2-c01&orientation=portrait"
                  alt="CSSBuy Spreadsheet - Guia de Compras"
                  title="CSSBuy Spreadsheet - Guia de Compras da China"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 md:w-32 md:h-32 rounded-2xl bg-accent-100/90 flex items-center justify-center">
                <div className="text-center">
                  <div className="text-lg md:text-2xl font-heading font-bold text-accent-700">2026</div>
                  <div className="text-xs text-accent-600">Guia Atualizado</div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-3/5">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium uppercase tracking-wider mb-4">
              Sobre o Guia
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-5">
              {t("sectionAbout")}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {t("sectionAboutDesc")}
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
              {[
                { icon: "ri-money-dollar-circle-line", text: "Economize dinheiro comparando preços reais" },
                { icon: "ri-shield-check-line", text: "Evite vendedores ruins ou scams" },
                { icon: "ri-star-line", text: "Encontre produtos de melhor qualidade" },
                { icon: "ri-global-line", text: "Acesse produtos exclusivos da China" },
              ].map((item, idx) => (
                <div key={idx} className="flex items-start gap-2.5">
                  <span className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-primary-600 text-sm`}></i>
                  </span>
                  <span className="text-sm text-foreground-700">{item.text}</span>
                </div>
              ))}
            </div>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t("btnAccessGuide")} <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}